import { createAction } from '@reduxjs/toolkit';

export const setGooglePayButtonVisibility = createAction<'visible' | 'hidden', 'SET_GOOGLE_PAY_BUTTON_VISIBILITY'>(
  'SET_GOOGLE_PAY_BUTTON_VISIBILITY',
);
